@if (report$ | async; as report) {
  <div class="gen-info">
    <div class="gen-info__row">
      <span class="gen-info__row_title">Summary: </span>
      {{report.all_snps_reports.report.individual_report?.summary}}
    </div>
    <div class="gen-info__chart" echarts [options]="chartOption"></div>
    <div class="gen-info__row">
      {{report.all_snps_reports.report.individual_report?.result}}
    </div>
    <div class="gen-info__hr"></div>
    <div class="rate-table">
      <div class="rate-table__row rate-table__row_title">
        <div class="rate-table__col rate-table__col_name">Referenced Studies:</div>
        <div class="rate-table__col rate-table__col_rate">Scientific rigor:</div>
      </div>
      @for (study of refactorStudies(report.SNPs); track study) {
        <div class="rate-table__row">
          <a class="rate-table__col rate-table__col_name" href="https://{{study.link}}" target="_blank">{{study.citation}}</a>
          <div class="rate-table__col rate-table__col_rate">
            <app-dashboard-viewer-data-zone-genetics-rating [rating]="study.score"></app-dashboard-viewer-data-zone-genetics-rating>
          </div>
        </div>
      }
    </div>
  </div>
}
